export default __webpack_public_path__ + "static/media/EditIconEvaluation.5765ef11.svg";